import type { ReactNode } from "react";
import { Note } from "./note";

/** What stops an action, under a title: the box of every such list, and of what a screen says in its own words. */
export function IssueBox({ title, children }: { title: string; children: ReactNode }) {
  return (
    <Note tone="danger">
      <p className="font-medium">{title}</p>
      {children}
    </Note>
  );
}
